<template>
    <div>
      <div class="loading-spinner-outer" v-if="saving">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Saving, please wait
          </div>
        </div>
      </div>
      <div class="loading-spinner-outer" v-if="searching">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Searching...
          </div>
        </div>
      </div>
        <div class="box mb-3 mb-6-sm">
            <div class="box-content">
                <h3 class="txt-primary mt-0 flex"><i class="fal fa-check"></i> Step 1) Enter Lead Details</h3>
                <div class="leads-list-item">
                    <div class="content">
                        <div class="top">
                            <div class="system-type p-3">
                                <div>
                                    <strong>System:</strong>
                                    <span v-if="lead.epwin_system_type !== null"> {{ lead.epwin_system_type.label }} </span>
                                    <span v-else>N/A</span>
                                </div>
                            </div>
                            <div class="type p-3">
                                <div>
                                    <strong>Type:</strong> <span>{{ lead.type }}</span>
                                </div>
                            </div>
                            <div class="source p-3">
                                <div>
                                    <strong>Source:</strong> <span>{{ lead.source }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="contact-details">
                            <div class="p-3">
                                <strong>Contact Details:</strong>
                            </div>
                            <div class="p-3">
                                <i class="fal fa-user txt-primary pr-2"></i>
                                <span v-if="lead.name !== null"> {{ lead.name }} </span>
                                <span v-else>--</span>
                            </div>
                            <div class="p-3">
                                <i class="fal fa-envelope txt-primary pr-2"></i>
                                <span v-if="lead.email !== null"> {{ lead.email }} </span>
                                <span v-else>--</span>
                            </div>
                            <div class="p-3">
                                <i class="fal fa-phone txt-primary pr-2"></i>
                                <span v-if="lead.phone !== null"> {{ lead.phone }} </span>
                                <span v-else>--</span>
                            </div>
                        </div>
                        <div class="address p-3">
                            <strong>Address: </strong>
                            <span v-if="lead.address !== null"> {{ lead.address }}, </span>
                            <span v-if="lead.postcode !== null"> {{ lead.postcode }} </span>
                        </div>
                        <div class="bottom">
                            <div class="details p-3">
                                <span>{{ lead.details }}</span>
                            </div>
                        </div>
                    </div>
                  <div class="lead-attachments">
                    <a class="attachment cursor-pointer" v-for="(attachment, index) in lead.lead_attachments" target="_blank" @click.stop-prevent="downloadAttachment(attachment.id)"
                       :data-filename="attachment.file_name">
                      <div class="icon">
                        <i class="fal fa-paperclip"></i>
                      </div>
                      <div class="filename">
                        {{ attachment.file_name }}
                      </div>
                    </a>
                  </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <h3 class="txt-primary mt-0">Step 2) Assign to users</h3>
                <div class="lead-assign-to">
                    <div class="flex mb-6 justify-end">
                      <div class="pr-3">
                        <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:255px;">
                          <div class="multi-select-input-placeholder">
                            Search Mode
                            <template v-if="search_mode === 'address'">
                              (Address)
                            </template>
                            <template v-if="search_mode === 'areas_served'">
                              (Areas Supplied)
                            </template>
                            <div class="dropdown-icon">
                              <i class="fal fa-chevron-down"></i>
                            </div>
                          </div>
                          <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                            <div class="multi-select-input-group">
                              <h1 class="input-group-title">Search Mode</h1>
                              <div class="checkboxes">
                                <div class="checkbox level-1">
                                  <label>
                                    <input type="radio" name="search_mode" value="address" v-model="search_mode">
                                    <span class="checkbox-label">Address Distance</span>
                                  </label>
                                </div>
                                <div class="checkbox level-1">
                                  <label>
                                    <input type="radio" name="search_mode" value="areas_served" v-model="search_mode">
                                    <span class="checkbox-label">Areas Supplied</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
<!--                        <div class="pr-3">-->
<!--                          <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:215px;">-->
<!--                            <div class="multi-select-input-placeholder">-->
<!--                              Choose Company Type...-->
<!--                              <div class="dropdown-icon">-->
<!--                                <i class="fal fa-chevron-down"></i>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                            <div class="multi-select-input-inner" v-show="filter_dropdown_open">-->
<!--                              <div class="multi-select-input-group">-->
<!--                                <h1 class="input-group-title">Company Types</h1>-->
<!--                                <div class="checkboxes">-->
<!--                                  <div class="checkbox level-1" v-for="company_type in all_company_types">-->
<!--                                    <label>-->
<!--                                      <input type="checkbox" name="company_types" :value="company_type.id" v-model="selected_company_types">-->
<!--                                      <span class="checkbox-label">{{ company_type.label }}</span>-->
<!--                                    </label>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
                        <div class="pr-3" v-show="search_mode === 'address'">
                          <div class="multi-select-input" @click.stop="address_type_dropdown_open = !address_type_dropdown_open" style="min-width:215px;">
                            <div class="multi-select-input-placeholder">
                              Choose Address Type...
                              <div class="dropdown-icon">
                                <i class="fal fa-chevron-down"></i>
                              </div>
                            </div>
                            <div class="multi-select-input-inner" v-show="address_type_dropdown_open">
                              <div class="multi-select-input-group">
                                <h1 class="input-group-title">Address Types</h1>
                                <div class="checkboxes">
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="radio" name="address_types" value="company" v-model="address_type">
                                      <span class="checkbox-label">Company Address</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="radio" name="address_types" value="showroom" v-model="address_type">
                                      <span class="checkbox-label">Showroom Address</span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                            <input type="text" placeholder="Search Company Name ..." class="form-control" v-model="company_name_search_query" :disabled="searching">
                        </div>
                    </div>
                    <table class="table_leads-assign-to-list">
                        <template v-for="(address, index) in addresses">
                            <thead>
                            <tr>
                                <th style="width: 35px;"><input type="checkbox" v-model="assigned_to_list" :value="address.company.id"> </th>
                                <th class="th_company-name">
<!--                                  {{ address.company.company_type.label }} - -->
                                  {{ address.company.name }}
                                  <a :href="`/company/${address.company.id}`" target="_blank">
                                    <i class="fa fa-eye"></i>
                                  </a>
                                  <div class="mt-3 txt-sm" v-show="search_mode === 'areas_served'">
                                    <template v-if="lead.type === 'commercial'">
                                        Commercial Areas Supplied:
                                      <span v-for="postcode in address.company.commercial_postcode_areas" class="area-served-label" :class="{ '_highlight' : lead_postcode_prefix === postcode.postcode_prefix }">
                                      {{ postcode.postcode_prefix }}
                                      </span>
                                    </template>
                                    <template v-else>
                                        Areas Supplied:
                                      <span v-for="postcode in address.company.postcode_areas" class="area-served-label" :class="{ '_highlight' : lead_postcode_prefix === postcode.postcode_prefix }">
                                      {{ postcode.postcode_prefix }}
                                      </span>
                                    </template>
                                  </div>
                                </th>
                                <th class="th_address txt-sm" v-if="search_mode === 'address'">
                                        Address:
                                        {{ address.line_1 }},
                                        <template v-if="address.line_2">
                                            {{ address.line_2 }},
                                        </template>
                                        {{ address.town }},
                                        {{ address.county }},
                                        {{ address.postcode }} - {{ getDistanceInMiles(address.distance) }} Miles
                                </th>
                                <th class="th_open-user-list">
                                    <label class="cursor-pointer">
                                        <input type="checkbox" class="hide" v-model="user_list_open" :value="address.company.id">
                                        <i class="fal fa-chevron-down" v-show="!isOpen(address.company.id)"></i>
                                        <i class="fal fa-chevron-up" v-show="isOpen(address.company.id)"></i>
                                    </label>
                                </th>
                            </tr>
                            </thead>
                            <tr v-show="isOpen(address.company.id)">
                                <td colspan="3">
                                  <h4>
                                    Lead Recipients:
                                  </h4>
                                    <div class="mb-1" v-for="lead_recipient in address.company.lead_recipients">
                                      {{ lead_recipient.name }} - {{ lead_recipient.email }}
                                      <a :href="`/manage-customer/${lead_recipient.id}`" target="_blank">
                                        <i class="fa fa-eye"></i>
                                      </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </table>
                    <template>
                        <div class="pagination-bar wrapper mb-3 mt-3">
                            <div class="row">
                                <div class="col">
                                    <a @click.prevent="prevPage()" v-if="current_page > 1"
                                       class="btn-default _sm"><i
                                            class="fa fa-caret-left"></i></a>
                                    <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                                    <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                                       class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                                </div>
                                <div class="col align-right">
                                    <div class="mt-1 mb-1">
                                        {{ total_count }} results found
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                  <template v-if="search_mode === 'address' && total_count_no_location > 0">
                    <h3 class="txt-primary mt-6">Unknown distances</h3>
                    <table class="table_leads-assign-to-list">
                      <template v-for="(address, index) in addresses_no_location">
                        <thead>
                        <tr>
                          <th style="width: 35px;"><input type="checkbox" v-model="assigned_to_list" :value="address.company.id"> </th>
                          <th class="th_company-name">
<!--                            {{ address.company.company_type.label }} - -->
                            {{ address.company.name }}
                            <a :href="`/company/${address.company.id}`" target="_blank">
                              <i class="fa fa-eye"></i>
                            </a>
                          </th>
                          <th class="th_address txt-sm">
                            Address:
                            {{ address.line_1 }},
                            <template v-if="address.line_2">
                              {{ address.line_2 }},
                            </template>
                            {{ address.town }},
                            {{ address.county }},
                            {{ address.postcode }}
                          </th>
                          <th class="th_open-user-list">
                            <label class="cursor-pointer">
                              <input type="checkbox" class="hide" v-model="user_list_open" :value="address.company.id">
                              <i class="fal fa-chevron-down" v-show="!isOpen(address.company.id)"></i>
                              <i class="fal fa-chevron-up" v-show="isOpen(address.company.id)"></i>
                            </label>
                          </th>
                        </tr>
                        </thead>
                        <tr v-show="isOpen(address.company.id)">
                          <td colspan="3">
                            <h4>
                              Lead Recipients:
                            </h4>
                            <div class="mb-1" v-for="lead_recipient in address.company.lead_recipients">
                              {{ lead_recipient.name }} - {{ lead_recipient.email }}
                              <a :href="`/manage-customer/${lead_recipient.id}`" target="_blank">
                                <i class="fa fa-eye"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </table>
                    <template>
                      <div class="pagination-bar wrapper mb-3 mt-3">
                        <div class="row">
                          <div class="col">
                            <a @click.prevent="prevPageNoLocation()" v-if="current_page_no_location > 1"
                               class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page_no_location }} / {{ total_pages_no_location }}</a>
                            <a @click.prevent="nextPageNoLocation()" v-if="current_page_no_location < total_pages_no_location"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                          </div>
                          <div class="col align-right">
                            <div class="mt-1 mb-1">
                              {{ total_count_no_location }} results found
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <div class="mt-3 align-right">
                    <a class="btn-primary" @click.prevent="assignLead()">
                      Assign Lead
                    </a>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'logged_in_user',
      'system_types',
      'lead',
      'statuses',
      // 'all_company_types',
      'postcode_prefixes',
    ],
    data() {
      return {
        saving: false,
        searching: false,
        addresses: [],
        addresses_no_location: [],
        company_name_search_query: '',
        current_page: 1,
        current_page_no_location: 1,
        // selected_company_types: [],
        total_count: 0,
        total_pages: 0,
        total_count_no_location: 0,
        total_pages_no_location: 0,
        limit: 20,
        assigned_to_list: [],
        user_list_open: [],
        filter_dropdown_open: false,
        address_type_dropdown_open: false,
        address_type: 'company',
        search_mode: 'areas_served',
      }
    },
    mounted() {
      this.loadUsers();
      this.loadUsersWithNoLocation();
    },
    methods: {
      loadUsers: _.debounce(function() {
        this.searching = true;
        axios.post('/leads/getNearestCustomers', {
          lead_id: this.lead.id,
          page_number: this.current_page,
          company_name_search_query: this.company_name_search_query,
          // selected_company_types: this.selected_company_types,
          limit: this.limit,
          address_type: this.address_type,
          search_mode: this.search_mode,
        }).then((response) => {
          this.addresses = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;

          if(this.search_mode === 'areas_served') {
            this.searching = false;
          }
        });
      }, 250),
      loadUsersWithNoLocation: _.debounce(function() {
        axios.post('/leads/getCustomersWithNoLocationData', {
          lead_id: this.lead.id,
          page_number: this.current_page_no_location,
          company_name_search_query: this.company_name_search_query,
          // selected_company_types: this.selected_company_types,
          limit: this.limit,
          address_type: this.address_type,
        }).then((response) => {
          this.addresses_no_location = response.data.data;
          this.total_count_no_location = response.data.total;
          this.total_pages_no_location = response.data.last_page;
          this.searching = false;
        });
      }, 250),
      prevPage() {
        this.current_page = this.current_page - 1;
        this.loadUsers();
      },
      nextPage() {
        this.current_page = this.current_page + 1;
        this.loadUsers();
      },
      prevPageNoLocation() {
        this.current_page_no_location = this.current_page_no_location - 1;
        this.loadUsersWithNoLocation();
      },
      nextPageNoLocation() {
        this.current_page_no_location = this.current_page_no_location + 1;
        this.loadUsersWithNoLocation();
      },
      downloadAttachment(attachment_id) {
        axios.post( '/leads/download-attachment', {
          attachment_id: attachment_id,
        }).then((response) => {
          window.location.href = response.data;
        });
      },
      getDistanceInMiles(distance) {
        return Math.round(distance / 1000 * 0.62137);
      },
      assignLead() {

        if(this.assigned_to_list.length === 0) {
          Swal.fire({
            title: 'No customers selected',
            icon: 'warning',
          });
          return;
        }

        this.saving = true;
        axios.post('/leads/assign', {
          lead_id: this.lead.id,
          assigned_to_list: this.assigned_to_list,
        }).then((response) => {
          window.location.href = `/leads`;
        });
      },
      isOpen(id) {
        return this.user_list_open.includes(id);
      },
    },
    computed: {
      lead_postcode_prefix() {
        if (!this.lead?.postcode) return '';

        const cleaned = this.lead.postcode
          .toUpperCase()
          .trim();

        const match = cleaned.match(/^[A-Z]+/);

        return match ? match[0] : '';
      }
    },
    watch: {
      async company_name_search_query() {
        this.current_page = 1;
        this.current_page_no_location = 1;
        await this.loadUsers();
        await this.loadUsersWithNoLocation();
      },
      // selected_company_types() {
      //   this.current_page = 1;
      //   this.current_page_no_location = 1;
      //   this.loadUsers();
      //   this.loadUsersWithNoLocation();
      // },
      async address_type() {
        this.current_page = 1;
        this.current_page_no_location = 1;
        await this.loadUsers();
        await this.loadUsersWithNoLocation();
      },
      async search_mode() {
        this.current_page = 1;
        this.current_page_no_location = 1;
        await this.loadUsers();

        if(this.search_mode === 'address') {
          await this.loadUsersWithNoLocation();
        }
      },
    },
  };
</script>
